// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1nevU","option":"styles_option__rIw1P","active":"styles_active__VGU32"};